module.exports = __webpack_public_path__ + "static/img/arrow_right.c5b6ca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/assets/arrow_right.png
// module id = JoFe
// module chunks = 0